export { default as Visualizador } from './Visualizador';
